import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { enviroment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredDialogComponent } from '../modules/session-expired-dialog/session-expired-dialog.component';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private dialog: MatDialog) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('cognito-idp.') || request.url.includes('amazonaws.com')) {
      return next.handle(request).pipe(
        catchError(err => this.handleError(err))
      );
    }
    if (request.url.startsWith(enviroment.API_URL)) {
      const token = localStorage.getItem('idToken');
      
      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `${token}`,
            'Content-Type': 'application/json' 
          }
        });
      }
    }
    
    return next.handle(request).pipe(
      catchError(err => this.handleError(err))
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 401) {
      this.dialog.open(SessionExpiredDialogComponent, {
        width: '550px',
        height: '150px',
        disableClose: true
      });
    }

    return throwError(() => error);
  }
} 